var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"htmlContent",domProps:{"innerHTML":_vm._s(_vm.perInfoList)}})
}
var staticRenderFns = []

export { render, staticRenderFns }